import React, { useState, useMemo } from 'react';
import { ArrowUpDown } from 'lucide-react';

export const CountriesTable = ({ data, onSort }) => {
  const columns = [
    { key: 'country', label: 'COUNTRY', sortable: false },
    { key: 'dcu_cnt', label: 'DCUS', sortable: false },
    { key: 'connected_dcu_cnt', label: 'CONNECTED DCUS', sortable: false },
    { key: 'percent_connected', label: '% CONNECTED', sortable: false },
    { key: 'active_ppu_cnt', label: 'PPUS', sortable: false },
    { key: 'consumer_record_cnt', label: 'CONSUMER RECORDS', sortable: false }
  ];

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return data;
    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key] ?? '';
      const bValue = b[sortConfig.key] ?? '';
      if (typeof aValue === 'string') {
        return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      } else {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
      }
    });
  }, [data, sortConfig]);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  return (
    <div>
      <div className="mb-2">
        <h3 className="text-base font-semibold text-gray-900">Countries</h3>
        <p className="text-sm text-gray-500">Geographic compliance metrics ({data.length.toLocaleString()} total)</p>
      </div>
    <div className="overflow-y-auto border rounded-lg" style={{ maxHeight: "750px" }}>
      <table className="w-full">
        <thead className="bg-gray-50 sticky top-0 z-10">
          <tr className="border-b border-gray-200">
            {columns.map((col) => (
              <th key={col.key} className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider py-3 px-4">
                <div className="flex items-center gap-1 cursor-pointer" onClick={() => col.sortable && handleSort(col.key)}>
                  {col.label}
                  {col.sortable && <ArrowUpDown className={`w-3 h-4 cursor-pointer ${sortConfig.key === col.key ? 'text-red-500 rotate-180' : 'text-gray-400'}`}/>}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row) => (
            <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
              <td className="py-4 px-4 text-gray-700">{row.country}</td>
              <td className="py-4 px-4 text-gray-700">{row.dcu_cnt}</td>
              <td className={`py-4 px-4 font-medium ${row.connected_dcu_cnt === 0 ? 'text-red-600' : 'text-green-600'}`}>
                {row.connected_dcu_cnt}
              </td>
              <td className="py-4 px-4 text-gray-700">{row.dcu_cnt === 0 ? '0%' : ((row.connected_dcu_cnt / row.dcu_cnt) * 100).toFixed(2) + '%'}</td>
              <td className="py-4 px-4 text-gray-700">{row.active_ppu_cnt}</td>
              <td className="py-4 px-4 text-gray-700">{row.consumer_record_cnt.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};